import styled from 'styled-components';

const Container = styled.div`
  z-index: 99999 !important;

  margin: 10px;

  :hover {
    color: white;
  }
`;

export default Container;
